// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__5KMQ2","loading":"skeleton_loading__Ug+6v"};